module.exports = __webpack_public_path__ + "img/distributionEnergy.4f5c7932.jpeg";